import {differenceInMilliseconds} from 'date-fns';
import Long from 'long';
import toNumber from '../toNumber';

export default function getDiffToStamp(stamp?: Long | number | null): number {
  return differenceInMilliseconds(toNumber(stamp), new Date());
}